// InterviewList.jsx
import React from "react";
import InterviewListRow from "./InterviewListRow";
import { AppCard } from "../ui";
import "./interviews.scss";

function getPaginationNumbers(current, total) {
  const pages = [];
  if (total <= 5) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
    pages.push(i);
  }
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}

const InterviewList = ({
  data = [],
  loading = false,
  hideActions = false,
  isStudentView = false,
  readOnly = false,
  basePath = "/interviews",
  page,
  setPage,
  pageSize,
  total,
}) => {
  const totalPages = pageSize && total ? Math.ceil(total / pageSize) : 0;

  return (
    <>
      <AppCard className="iv-table-card">
        <div className="iv-table-wrapper">
          <table className="iv-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Company</th>
                <th>Next Round</th>
                <th>Interviewer</th>
                <th>Status</th>
                {!readOnly && <th></th>}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={readOnly ? 5 : 6} className="iv-table__loading">
                    <div className="spinner-border spinner-border-sm" />
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={readOnly ? 5 : 6} className="iv-table__empty">
                    No interviews found
                  </td>
                </tr>
              ) : (
                data.map(iv => (
                  <InterviewListRow
                    key={iv._id}
                    interview={iv}
                    hideActions={hideActions}
                    isStudentView={isStudentView}
                    readOnly={readOnly}
                    basePath={basePath}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </AppCard>

      {/* Pagination */}
      {totalPages > 1 && setPage && (
        <div className="iv-pagination">
          <div className="iv-pagination__info">
            {total === 0 ? (
              <span>No entries</span>
            ) : (
              <span>
                Showing {((page - 1) * pageSize) + 1}–{Math.min(page * pageSize, total)} of {total}
              </span>
            )}
          </div>
          <div className="iv-pagination__controls">
            <button
              className="iv-page-btn"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              ‹
            </button>
            {getPaginationNumbers(page, totalPages).map((p, i) =>
              p === "..." ? (
                <span key={`e-${i}`} className="iv-page-ellipsis">…</span>
              ) : (
                <button
                  key={p}
                  className={`iv-page-btn${page === p ? " iv-page-btn--active" : ""}`}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              )
            )}
            <button
              className="iv-page-btn"
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages}
            >
              ›
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InterviewList;
